import CONSTANTS from '../../constants';

export function posConfig(state = {}, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.POS.GET.CONFIG:
            return action.config || {};
        default:
            return state
    }
}
